import HomePage from './screens/HomePage';

const routes = [
  {
  path: "/home",
  exact: true,
  name: "Inicio",
  icon: "fa fa-home",
  component: HomePage,
  layout: "/admin",
  sidebar: true,
  roleID: 'ALL'
} 

  ];
  
  export default routes;

